import * as React from "react";
import { Path, G, ClipPath, Defs, Rect, Mask } from "react-native-svg";

import { Icon, IconProps } from "../../primitive";

export const PFIcon = (props: IconProps) => (
  <Icon fill="none" viewBox="0 0 16 12" title="PF" {...props}>
    <G clipPath="url(#a)">
      <Rect width={16} height={12} fill="#fff" rx={1} />
      <Path
        fill="#F7FCFF"
        fillRule="evenodd"
        d="M0 0v12h16V0H0Z"
        clipRule="evenodd"
      />
      <Mask
        id="b"
        width={16}
        height={12}
        x={0}
        y={0}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: "luminance",
        }}
      >
        <Path
          fill="#fff"
          fillRule="evenodd"
          d="M0 0v12h16V0H0Z"
          clipRule="evenodd"
        />
      </Mask>
      <G mask="url(#b)">
        <Path
          fill="#BF2714"
          fillRule="evenodd"
          d="M0 0v3h16V0H0ZM0 9v3h16V9H0Z"
          clipRule="evenodd"
        />
        <Mask
          id="c"
          width={6}
          height={6}
          x={5}
          y={3}
          maskUnits="userSpaceOnUse"
          style={{
            maskType: "luminance",
          }}
        >
          <Path
            fill="#fff"
            fillRule="evenodd"
            d="M8 9a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z"
            clipRule="evenodd"
          />
        </Mask>
        <G mask="url(#c)">
          <Path
            fill="#5277B9"
            fillRule="evenodd"
            d="M5.274 6.882a.098.098 0 0 1 .143-.115l.187.109a.098.098 0 0 0 .091.004l.462-.216a.098.098 0 0 1 .099.01l.498.359.689-.371a.098.098 0 0 1 .086-.004l.518.226c.027.011.056.01.082-.002l.466-.224a.098.098 0 0 1 .079-.003l.575.23c.026.01.056.01.08-.003l.447-.22a.098.098 0 0 1 .089 0l.409.215c.03.015.065.015.094-.002l.213-.12a.098.098 0 0 1 .143.11l-.044.168H5.322l-.048-.15ZM5.272 7.475a.098.098 0 0 1 .145-.113l.17.102a.098.098 0 0 0 .094.005l.438-.213a.098.098 0 0 1 .102.01l.478.357.662-.37a.098.098 0 0 1 .088-.003l.495.223a.098.098 0 0 0 .085-.002l.443-.221a.098.098 0 0 1 .082-.003l.55.227c.027.011.057.01.083-.003l.424-.218a.098.098 0 0 1 .092.001l.389.211c.03.017.067.016.097-.001l.195-.115a.098.098 0 0 1 .145.11l-.042.164H5.318l-.046-.148ZM5.37 7.869a.098.098 0 0 1 .146-.113l.17.102a.098.098 0 0 0 .093.004l.439-.213a.098.098 0 0 1 .102.01l.478.357.662-.369a.098.098 0 0 1 .088-.004l.495.223a.098.098 0 0 0 .084-.001l.444-.222a.098.098 0 0 1 .081-.003l.55.228c.027.011.057.01.083-.003l.425-.218a.098.098 0 0 1 .092 0l.388.212c.03.016.067.016.097-.002l.195-.114a.098.098 0 0 1 .145.109l-.042.164H5.416l-.045-.147ZM5.961 8.262a.098.098 0 0 1 .145-.113l.17.102a.098.098 0 0 0 .093.005l.439-.213a.098.098 0 0 1 .102.01l.478.357.662-.37a.098.098 0 0 1 .088-.003l.495.223a.098.098 0 0 0 .084-.002l.444-.221a.098.098 0 0 1 .081-.003l.55.227c.027.012.057.01.083-.003l.425-.218a.098.098 0 0 1 .092.001l.389.211c.03.017.066.016.096-.001l.195-.115a.098.098 0 0 1 .145.11l-.042.164H6.006l-.045-.148ZM5.174 8.754a.098.098 0 0 1 .145-.113l.17.102a.098.098 0 0 0 .093.004l.439-.213a.098.098 0 0 1 .102.01l.478.358.662-.37a.098.098 0 0 1 .088-.003l.495.222a.098.098 0 0 0 .084-.001l.444-.222a.098.098 0 0 1 .082-.003l.55.228c.026.011.056.01.082-.003l.425-.218a.098.098 0 0 1 .092.001l.389.211c.03.017.067.016.096-.002l.195-.114a.098.098 0 0 1 .146.11l-.043.164H5.22l-.046-.148Z"
            clipRule="evenodd"
          />
          <Path
            fill="red"
            d="M6.334 4.723h.5l-.012 1.976c.084.266.204.37.39.37v.5c-.423 0-.722-.26-.878-.795V4.723ZM9.714 4.723h-.5l.011 1.976c-.084.266-.203.37-.389.37v.5c.422 0 .72-.26.878-.795V4.723Z"
          />
          <Path
            fill="red"
            fillRule="evenodd"
            d="M8.362 3.454s-.829-.216-.829.333V5.52l.967.287V4.39s-.484-.296-.484-.527c0-.23.346-.41.346-.41Z"
            clipRule="evenodd"
          />
          <Path
            stroke="#000"
            strokeWidth={0.5}
            d="m6.967 6.445.315-.403M7.254 6.432l-.302-.405M7.42 6.445l.315-.403M7.707 6.432l-.302-.405M7.852 6.445l.316-.403M8.14 6.432l-.302-.405M8.305 6.445l.315-.403M8.592 6.432l-.302-.405M8.757 6.445l.315-.403M9.045 6.432l-.303-.405"
          />
          <Path
            fill="#FA8F21"
            d="M6.285 6.017v.563H5.242l-.123-.621 1.166.058Zm4.532.563H9.774v-.563l1.166-.058-.123.62ZM6.305 5.426v.437l-1.036-.106v-.73l1.036.399Zm4.485.33-1.035.107v-.437l1.035-.399v.73ZM7.32 5.56l-.048.185-.388-.185v-.35l.435.35Zm1.856 0-.389.185-.047-.185.436-.35v.35Zm-1.842-.537v.368l-.436-.368v-.478h-.47l-.432-.457.432-.514.906 1.45Zm2.73-.935-.432.457H9.16v.478l-.436.368v-.368l.907-1.449.431.514Zm-3.738.604-.061.582-.787-.377.194-.764.654.56Zm4.255.205-.786.377-.062-.582.655-.56.193.765Zm-3.182-1.35-.073 1.17-.599-1.17.6-.23.072.23Zm1.933 0-.599 1.17-.073-1.17.073-.23.599.23Z"
          />
        </G>
      </G>
    </G>
    <Defs>
      <ClipPath id="a">
        <Rect width={16} height={12} fill="#fff" rx={1} />
      </ClipPath>
    </Defs>
  </Icon>
);
